import commitMutation from 'relay-commit-mutation-promise';
import { graphql, Environment } from 'react-relay';

import {
    profileArticlesMutation as MutationType,
    FirmDesignProfileArticleMutationInput,
    profileArticlesMutationResponse,
} from './__generated__/profileArticlesMutation.graphql';

const mutation = graphql`
    mutation profileArticlesMutation($input: FirmDesignProfileArticleMutationInput!) {
        firmDesignProfileArticleMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    articles {
                        photo {
                            path
                            serviceId
                        }
                        title
                        description
                        webLink {
                            url
                        }
                    }
                }
            }
        }
    }
`;

export const profileArticlesMutation = async (
    environment: Environment,
    variables: FirmDesignProfileArticleMutationInput
): Promise<profileArticlesMutationResponse> => {
    return await commitMutation<MutationType>(environment, {
        mutation,
        variables: { input: variables },
    });
};
